// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.newsletter-section {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 60px 20px;
  border-radius: 16px;
  margin: 40px 0;
  color: white;
}

.newsletter-section.dark-mode {
  background: transparent;
  padding: 0;
  margin: 0;
}

.newsletter-section.no-header {
  padding: 0;
  margin: 0;
}

.newsletter-content {
  max-width: 600px;
  margin: 0 auto;
  text-align: center;
}

.dark-mode .newsletter-content {
  margin: 0;
  text-align: left;
  max-width: 100%;
}

.newsletter-title {
  font-size: 2rem;
  font-weight: 800;
  margin-bottom: 12px;
  margin-top: 0;
  line-height: 1.2;
}

.newsletter-subtitle {
  font-size: 1.05rem;
  opacity: 0.95;
  margin-bottom: 32px;
  line-height: 1.6;
}

.newsletter-form {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 12px;
  margin-bottom: 20px;
}

.dark-mode .newsletter-form {
  max-width: 500px;
}

.newsletter-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.newsletter-icon {
  position: absolute;
  left: 16px;
  color: #999;
  pointer-events: none;
}

.newsletter-input {
  width: 100%;
  padding: 14px 16px 14px 44px;
  border: 1px solid rgba(0,0,0,0.1);
  border-radius: 8px;
  font-size: 1rem;
  background: white;
  color: #333;
  outline: none;
  transition: all 0.3s ease;
}

.dark-mode .newsletter-input {
  border: 2px solid #eee;
  padding: 18px 16px 18px 48px;
  border-radius: 100px;
}

.newsletter-input:focus {
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.2);
}

.dark-mode .newsletter-input:focus {
  border-color: #3b82f6;
  box-shadow: none;
}

.newsletter-input::placeholder {
  color: #999;
}

.newsletter-input:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.newsletter-button {
  padding: 14px 32px;
  background: white;
  color: #667eea;
  border: none;
  border-radius: 8px;
  font-weight: 700;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
}

.dark-mode .newsletter-button {
  background: #000;
  color: #fff;
  border-radius: 100px;
  padding: 14px 40px;
}

.newsletter-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
}

.newsletter-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.newsletter-button .spinner {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.newsletter-notice {
  font-size: 0.85rem;
  opacity: 0.85;
  margin: 0;
}

.dark-mode .newsletter-notice {
  color: #999;
}

/* Success Message */
.success-message {
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.success-icon {
  font-size: 3rem;
  color: #4ade80;
  animation: bounce 0.6s ease;
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

.success-message h2 {
  margin: 0;
  font-size: 1.8rem;
}

.success-message p {
  margin: 0;
  opacity: 0.95;
  font-size: 1.05rem;
}

/* Responsive */
@media (max-width: 768px) {
  .newsletter-section {
    padding: 40px 16px;
  }

  .newsletter-title {
    font-size: 1.5rem;
  }

  .newsletter-subtitle {
    font-size: 0.95rem;
    margin-bottom: 24px;
  }

  .newsletter-form {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .newsletter-button {
    width: 100%;
  }

  .dark-mode .newsletter-form {
    max-width: 100%;
  }
}

@media (max-width: 480px) {
  .newsletter-section {
    padding: 30px 12px;
    margin: 30px 0;
    border-radius: 12px;
  }

  .newsletter-title {
    font-size: 1.3rem;
    margin-bottom: 8px;
  }

  .newsletter-subtitle {
    font-size: 0.9rem;
    margin-bottom: 20px;
  }

  .newsletter-input {
    padding: 12px 12px 12px 40px;
    font-size: 16px;
  }

  .newsletter-button {
    padding: 12px 24px;
    font-size: 0.9rem;
  }

  .newsletter-notice {
    font-size: 0.8rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/NewsletterSignup.css"],"names":[],"mappings":"AAAA;EACE,6DAA6D;EAC7D,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,4BAA4B;IAC5B,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".newsletter-section {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  padding: 60px 20px;\n  border-radius: 16px;\n  margin: 40px 0;\n  color: white;\n}\n\n.newsletter-section.dark-mode {\n  background: transparent;\n  padding: 0;\n  margin: 0;\n}\n\n.newsletter-section.no-header {\n  padding: 0;\n  margin: 0;\n}\n\n.newsletter-content {\n  max-width: 600px;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.dark-mode .newsletter-content {\n  margin: 0;\n  text-align: left;\n  max-width: 100%;\n}\n\n.newsletter-title {\n  font-size: 2rem;\n  font-weight: 800;\n  margin-bottom: 12px;\n  margin-top: 0;\n  line-height: 1.2;\n}\n\n.newsletter-subtitle {\n  font-size: 1.05rem;\n  opacity: 0.95;\n  margin-bottom: 32px;\n  line-height: 1.6;\n}\n\n.newsletter-form {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.dark-mode .newsletter-form {\n  max-width: 500px;\n}\n\n.newsletter-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.newsletter-icon {\n  position: absolute;\n  left: 16px;\n  color: #999;\n  pointer-events: none;\n}\n\n.newsletter-input {\n  width: 100%;\n  padding: 14px 16px 14px 44px;\n  border: 1px solid rgba(0,0,0,0.1);\n  border-radius: 8px;\n  font-size: 1rem;\n  background: white;\n  color: #333;\n  outline: none;\n  transition: all 0.3s ease;\n}\n\n.dark-mode .newsletter-input {\n  border: 2px solid #eee;\n  padding: 18px 16px 18px 48px;\n  border-radius: 100px;\n}\n\n.newsletter-input:focus {\n  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.2);\n}\n\n.dark-mode .newsletter-input:focus {\n  border-color: #3b82f6;\n  box-shadow: none;\n}\n\n.newsletter-input::placeholder {\n  color: #999;\n}\n\n.newsletter-input:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.newsletter-button {\n  padding: 14px 32px;\n  background: white;\n  color: #667eea;\n  border: none;\n  border-radius: 8px;\n  font-weight: 700;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  white-space: nowrap;\n}\n\n.dark-mode .newsletter-button {\n  background: #000;\n  color: #fff;\n  border-radius: 100px;\n  padding: 14px 40px;\n}\n\n.newsletter-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);\n}\n\n.newsletter-button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.newsletter-button .spinner {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.newsletter-notice {\n  font-size: 0.85rem;\n  opacity: 0.85;\n  margin: 0;\n}\n\n.dark-mode .newsletter-notice {\n  color: #999;\n}\n\n/* Success Message */\n.success-message {\n  padding: 40px 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n}\n\n.success-icon {\n  font-size: 3rem;\n  color: #4ade80;\n  animation: bounce 0.6s ease;\n}\n\n@keyframes bounce {\n  0%, 100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-10px);\n  }\n}\n\n.success-message h2 {\n  margin: 0;\n  font-size: 1.8rem;\n}\n\n.success-message p {\n  margin: 0;\n  opacity: 0.95;\n  font-size: 1.05rem;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .newsletter-section {\n    padding: 40px 16px;\n  }\n\n  .newsletter-title {\n    font-size: 1.5rem;\n  }\n\n  .newsletter-subtitle {\n    font-size: 0.95rem;\n    margin-bottom: 24px;\n  }\n\n  .newsletter-form {\n    grid-template-columns: 1fr;\n    gap: 10px;\n  }\n\n  .newsletter-button {\n    width: 100%;\n  }\n\n  .dark-mode .newsletter-form {\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .newsletter-section {\n    padding: 30px 12px;\n    margin: 30px 0;\n    border-radius: 12px;\n  }\n\n  .newsletter-title {\n    font-size: 1.3rem;\n    margin-bottom: 8px;\n  }\n\n  .newsletter-subtitle {\n    font-size: 0.9rem;\n    margin-bottom: 20px;\n  }\n\n  .newsletter-input {\n    padding: 12px 12px 12px 40px;\n    font-size: 16px;\n  }\n\n  .newsletter-button {\n    padding: 12px 24px;\n    font-size: 0.9rem;\n  }\n\n  .newsletter-notice {\n    font-size: 0.8rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
